import { useFormikContext } from "formik";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { CommandIsland } from "@design-system/CommandIsland/CommandIsland";
import { VStack } from "@design-system/VStack/VStack";
import type { ApplyCloseTemplateWizardValues } from "./applyCloseTemplate.schema";
import { SCHEDULE_TEMPLATE_STEPS } from "./scheduleTemplateStep.constants";
import { ScheduleTemplateStepTeam } from "./ScheduleTemplateStepTeam";
import styles from "./ScheduleWizardStepDefaults.module.scss";

interface Props {
    /** Returns to the occurrences step. */
    onBack: () => void;
    /** Advances the schedule wizard to entity selection. */
    onContinue: () => void;
}

export const ScheduleWizardStepTeam = ({ onBack, onContinue }: Props) => {
    const formik = useFormikContext<ApplyCloseTemplateWizardValues>();

    return (
        <div className={styles.wrapper}>
            <div className={styles.subtitleContainer}>Step 3 of 5 · Team</div>
            <div className={styles.container}>
                <div className={styles.left}>
                    <VStack gap={16} className={styles.leftFormContent}>
                        <section className={styles.formSection}>
                            <VStack gap={16}>
                                <VStack gap={4}>
                                    <h3 className={styles.sectionTitle}>
                                        {SCHEDULE_TEMPLATE_STEPS[3].label}
                                    </h3>
                                    <p className={styles.sectionDescription}>
                                        {SCHEDULE_TEMPLATE_STEPS[3].description}
                                    </p>
                                </VStack>
                                <ScheduleTemplateStepTeam formik={formik} />
                            </VStack>
                        </section>
                    </VStack>
                </div>
            </div>
            <div className={styles.commandBar}>
                <CommandIsland alignEnd className={styles.commandIsland}>
                    <ButtonWithLoader
                        variant="secondary"
                        size="md"
                        type="button"
                        loading={false}
                        onClick={onBack}
                    >
                        Back
                    </ButtonWithLoader>
                    <ButtonWithLoader
                        variant="primary"
                        size="md"
                        type="button"
                        loading={false}
                        onClick={onContinue}
                        hotKey="mod+enter"
                        hotKeyOptions={{
                            description: "Continue",
                            preventDefault: true,
                        }}
                        hotKeyDisplayPosition="inline"
                    >
                        Continue
                    </ButtonWithLoader>
                </CommandIsland>
            </div>
        </div>
    );
};
